import { apiHelper } from '@/utils'
import { API } from '@/constants'

/**
 * Which brands this agent may work in.
 *
 * Platform staff get the whole list and pick one; the chosen id goes out as
 * X-Tenant-Id on later calls. A client's own agent gets exactly one row and the
 * header is never read for them server-side, so the picker is simply hidden
 * rather than being a control that could be tampered with.
 */
export const tenantService = { list }

const API_URL = API.BASE_URL + '/v1'

export async function list() {
  return apiHelper(API_URL).get('/tenants')
}
